module.exports = __webpack_public_path__ + "img/image-placeholder-drop.1e2baced.svg";